<template>
	<div>
		<v-badge
				v-if="exceptionCount"
				:content="exceptionCount"
				color="red"
				overlap
				offset-x="12"
				offset-y="12"
				bordered
		>
			<v-btn color="blue" @click="onException">
				<span class="btnText">Exception</span>
			</v-btn>
		</v-badge>
		<v-btn
				v-else
				@click="onException"
				color="blue"
		>
			<span class="btnText">Exception</span>
		</v-btn>
	</div>
</template>

<script>

export default {
	name: "ExceptionBTN",
	props: {
		exceptionCount: Number,
	},
	methods: {
		onException() {
			this.$emit("updateException");
		}
	}
};
</script>
